import { forwardRef, useCallback, useState } from 'react'
import { CardBody, List, ListItem, Popover, Body, classNames } from '@panwds/react-ui'
import { MoreIcon } from '@panwds/icons'
import type { VFC, ReactNode } from 'react'
// import '...RCTree.scss'

export interface IconMenuItem {
  key?: string
  label: ReactNode
  value: any
  appearance?: 'default' | 'destructive'
  disabled?: boolean
  onClick?: (item: IconMenuItem) => void
}

const DotsButton = forwardRef<HTMLButtonElement, { className?: string, isOpen?: boolean }>(({ isOpen, className, ...props }, ref) => {
  return (
    <button
      ref={ref}
      style={{ height: 24, width: 24 }}
      className={classNames('context-btn cm-rounded-full cm-flex cm-items-center cm-justify-center cm-outline-none cm-border-0', className)}
      aria-label='context-icon'
      {...props}
    >
      <MoreIcon />
    </button>
  )
})
DotsButton.displayName = DotsButton.name

type IconMenuProps = { className?: string, iconMenuList: IconMenuItem[], onContextClick?: (item: IconMenuItem) => void }
const IconMenu: VFC<IconMenuProps> = ({ className, iconMenuList, onContextClick }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const onItemClick = useCallback((each) => {
    setIsOpen(false)
    each.onClick?.(each)
    onContextClick?.(each)
  }, [onContextClick])

  return (
    <div>
      <Popover
        defaultPlacement='bottom-start'
        isOpen={isOpen}
        onIsOpenChange={setIsOpen}
        label=''
        button={<DotsButton className={className} />}
      >
        <CardBody addClassName='cm-flex cm-flex-col cm-px-0 cm-py-0 cm-m-0'>
          <List style={{ width: '100%', padding: '0', backgroundColor: 'white' }}>
            {iconMenuList.map((each: any) => {
              const { label, value, key = String(value), appearance, disabled, onClick, ...rest } = each
              const color = (appearance === 'destructive' ? 'cm-m-0 cm-pl-6 cm-text-red-700 cm-content-center' : 'cm-m-0 cm-pl-6 cm-text-gray-900 dark:cm-text-gray-100 cm-content-center')
              const labelBody = <Body className={color} size='sm'>{label}</Body>
              if (disabled) {
                return <ListItem addClassName='cm-w-full' style={{ width: '100%', opacity: 0.6 }} disabled key={key} {...rest}>{labelBody}</ListItem>
              }
              return <ListItem addClassName='cm-w-full' key={key} onClick={onItemClick.bind(undefined, each)} {...rest}>{labelBody}</ListItem>
            })}
          </List>
        </CardBody>
      </Popover>
    </div>
  )
}

export default IconMenu
